import boletaApi from "./boletaApi";

export const getInvoicesByStatus = async (status) => {
  try {
    return await boletaApi.get("/getInvoicesByStatus", { params: { status } });
  } catch (error) {
    const { response } = error;
    return response;
  }
};
